import { render, staticRenderFns } from "./add-organizations-table.vue?vue&type=template&id=d9f6527c&scoped=true&"
import script from "./add-organizations-table.vue?vue&type=script&lang=ts&"
export * from "./add-organizations-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f6527c",
  null
  
)

export default component.exports